import { IntlTFunc } from 'next-intl';

import { OrderFragment, OrderItem, ProductFragment } from '@/fo/api/magento';

import { MappedProduct } from '../types';

import { utilMapProductData } from './utilMapProductData';

export const utilMapOrderProductData = (
  orderItem: NonNullable<OrderFragment['items']>[0] | OrderItem,
  t: IntlTFunc
): MappedProduct | null => {
  if (!orderItem?.product) {
    return null;
  }

  const product = orderItem.product as ProductFragment;
  const mappedProduct = utilMapProductData(product, t);
  const originalPrice =
    (orderItem as OrderItem)?.prices?.original_price_including_tax?.value ??
    null;

  return {
    ...mappedProduct,
    basePrice: originalPrice ?? mappedProduct.basePrice,
    quantity: orderItem.quantity_ordered ?? 0,
    productType: product.__typename
  };
};
